module.exports = __webpack_public_path__ + "static/media/mc_visa.2b46e383.svg";